module.exports = __webpack_public_path__ + "statics/img/1-1.c4576f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-1.png
// module id = eY1O
// module chunks = 1